import { CSSProperties } from 'glamor';
import { ERPGIcon } from 'motw_core/UI/Icons/ERPGIcon';
import * as React from 'react';
import RPGIcon from '../../../../presentation/Shared/RPGIcon/RPGIcon';
import { StyleClass } from '../../../../presentation/Shared/Styles/CSS';

export function ImageAtCorners({
	imageDistance,
	imageAtCornerSet
}: {
	imageDistance: number;
	imageAtCornerSet: ImageAtCornerSet;
}) {
	const cornerStyles = [
		{
			icon: imageAtCornerSet.topLeft.icon,
			top: `-${imageDistance}px`,
			left: `-${imageDistance}px`,
			maskImage: `linear-gradient(to bottom right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 100%, transparent)`,
			...imageAtCornerSet.topLeft.style
		},
		{
			icon: imageAtCornerSet.topRight.icon,
			top: `-${imageDistance}px`,
			right: `-${imageDistance}px`,
			maskImage: `linear-gradient(to top right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 100%, transparent)`,
			...imageAtCornerSet.topRight.style
		},
		{
			icon: imageAtCornerSet.bottomLeft.icon,
			bottom: `-${imageDistance}px`,
			left: `-${imageDistance}px`,
			maskImage: `linear-gradient(to top right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 100%, transparent)`,
			...imageAtCornerSet.bottomLeft.style
		},
		{
			icon: imageAtCornerSet.bottomRight.icon,
			bottom: `-${imageDistance}px`,
			right: `-${imageDistance}px`,
			maskImage: `linear-gradient(to bottom right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 100%, transparent)`,
			...imageAtCornerSet.bottomRight.style
		}
	];

	return (
		<span>
			{cornerStyles.map((cornerStyle, index) => (
				<CornerImage
					setName={imageAtCornerSet.setName}
					key={index}
					icon={cornerStyle.icon}
					withStyle={cornerStyle}
				/>
			))}
		</span>
	);
}

function CornerImage({
	setName,
	icon,
	withStyle
}: {
	setName: string;
	icon: ERPGIcon;
	withStyle: React.CSSProperties;
}) {
	const cornerStyle = {
		position: 'absolute' as 'absolute',
		fontSize: '33px',
		zIndex: -1,
		color: 'rgba(96, 79, 65)',
		opacity: 0.9,
		...withStyle
	};

	return <RPGIcon icon={icon} withClass={StyleClass(`cornerImage_${setName}_${icon}`, cornerStyle)} />;
}

class ImageAtCornerSet {
	constructor(
		readonly setName: string,
		readonly topLeft: ImageAtCorner,
		readonly topRight: ImageAtCorner,
		readonly bottomLeft: ImageAtCorner,
		readonly bottomRight: ImageAtCorner
	) {}
}

class ImageAtCorner {
	constructor(readonly icon: ERPGIcon, readonly style: CSSProperties) {}
}

const swalImageAtCornerSet = new ImageAtCornerSet(
	`standardSwal`,
	new ImageAtCorner(ERPGIcon.lion, { transform: `scale(-1, -1)` }),
	new ImageAtCorner(ERPGIcon.snake, {}),
	new ImageAtCorner(ERPGIcon['sea-serpent'], { transform: `rotate(200deg)` }),
	new ImageAtCorner(ERPGIcon.octopus, { transform: `rotate(180deg) scale(-1, -1)` })
);

export const ImageAtCornerSets = {
	swal: swalImageAtCornerSet
};
